// extracted by mini-css-extract-plugin
export default {"cls1":"wuqfqY38OQJ1asYf4qqp","cls2":"GRUY9Mzi_3RXRvmDg6vp wuqfqY38OQJ1asYf4qqp"};